import React, {Component} from 'react';

export default class AtividadeDia extends Component {

    css = {
        backgroundImage: 'url(' + this.props.imagemHabilitado + ')'
    };

    render() {
        return ([
            <button className={this.props.habilitado ? `botao-invisivel` : `botao-invisivel__disabled`} style={this.props.size} onClick={this.props.navegar} disabled={!this.props.habilitado} key={"button" + this.props.chave}>
                <div className={`card-atividades card-atividades__dia ${this.props.cssDesabilitado}`}>
                    {this.props.habilitado ? (
                        <div style={this.css} className="card-atividades__imagem">
                            {this.props.executado ? (
                                <img src="./feito.png" className="checkAtividade" alt="Check atividade realizada"></img>    
                            ) : (null)}
                        </div>
                    ) : (
                        <div className="card-atividades__imagem">
                            <img src={this.props.imagemDesabilitado} className="card-atividades__img__disabled" alt={this.props.imagemAlt + ' desabilitada'}></img>
                        </div>
                    )}
                </div>
            </button>,
            <div key={"div" + this.props.chave} style={(!this.props.last) ? ({minWidth:'1px', width:'1px', maxWidth:'1px', borderLeft:'solid 1px #dedede'}) : null}></div>
            ]
        )
    }
}